import React, { useContext, useState, useEffect } from "react";
import { PrintComponent } from "../Common/Controls/Print/Print";
import { useParams } from "react-router-dom";
import "./CentroImpresion.css";

const MiPerfil = () => {
  const [currentTab, setCurrentTab] = useState(0);
  let { reporte } = useParams();
  const urlComp = `CentroImpresion/Reportes/${reporte}/${reporte}.jsx`;

  return (
    <section className="CentroImpresion__Container">
      <div className="CentroImpresion__HeaderContainer">
        <h1>Centro de impresión</h1>
      </div>
      <div className="PrintSection__container">
        <PrintComponent urlComponent={urlComp} />
      </div>
    </section>
  );
};

export default MiPerfil;
